export enum ButtonSizeTypes {
  SM = "sm",
  DEFAULT = "default",
  LG = "lg",
  XL = "xl",
}
